document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  const input = form.querySelector('input[name="q"]');
  if (!input) return;

  const query = input.value.trim().toLowerCase().replace(/\s+/g, ' ');
  const synonyms = {
    'magen david': 'star of david',
    'david star': 'star of david',
    'jewish gift': 'jewish gifts',
    'israeli gift': 'israeli gifts',
    'shabbat candle': 'shabbat candles',
    'sabbath': 'shabbat',
    'menora': 'menorah',
    'chanukah': 'hanukkah',
    'hamsa hand': 'hamsa'
  };

  if (synonyms[query]) input.value = synonyms[query];
});